import { Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef, HostListener } from '@angular/core';
import { Approved, Specification, Sub, sendEmailmultiple } from 'src/app/service/modal/approved';
import { ShowHiddenService } from 'src/app/service/apiservice/showhidden.service';
import { ApprovedService } from 'src/app/service/apiservice/approved.service';
import { PendingRequestService } from '../../../service/apiservice/pendingrequest.service';
import { Remark } from '../../../service/modal/pendingrequest';
import { Globals } from '../../../globals';
import { DatePipe } from '@angular/common';
import { UploadFileS3BucketService } from '../../../service/apiservice/uploadFileS3Bucket.service';
import { Attachment } from '../../../service/modal/pendingrequest';
import { Router } from '@angular/router';
import { NgSelectComponent } from '@ng-select/ng-select';
import { NgForm, FormGroup, Validators, AbstractControl, FormControl, FormBuilder } from '@angular/forms';
declare var $;
declare function info_noti(msg: any): any;
@Component({
  selector: 'app-showhidden-hc',
  templateUrl: './showhidden-hc.component.html',
  styleUrls: ['./showhidden-hc.component.css']
})
export class ShowhiddenHcComponent implements OnInit {

  hiddenGrid: Approved[] = new Array();
  hiddenViewData: Approved = new Approved();
  addApprovedHealthCard: Approved = new Approved();
  submitted = false;
  @ViewChild('addForm') addForm: any;
  @ViewChild('AddCloseForm') addCloseForm: ElementRef;
  @ViewChild('AttachmentCloseForm') attachment_CloseForm: ElementRef;
  eyeIcon: string = "zmdi-eye-off";
  starIcon: string = "zmdi-star-outline";
  todayDate: any;
  showActions: boolean = false;
  selectedMailList = [];
  //subject DropDown//
  subjectDropDown: any;
  subjectDropDown_SelectedId: number[];
  //subject DropDown//

  //Specification DropDown//
  specificationDropDown: any;
  specificationDropDown_SelectedId: number[];
  //Specification DropDown//

  //Remark DropDown//
  remarkDropDown: any;
  remarkDropDown_SelectedId: number[];
  //Remark DropDown/
  //multiple action
  selectedActionList: Approved[] = new Array();;
  appvar: Approved;
  approvedObjActionShow = new Approved();
  checkClickCount = 0;
  genratedOtp;
  otpCheck;
  selectedFiles: File[];
  attchmentList: Attachment[] = new Array();
  attachdata = new Attachment();
  showhiddenAttachmentData: any;
  showhiddenAttachmentDataShow: any;
  hoveredIndex;

  //multiple email forward
  emailId;
  sendEmailmultiple = new sendEmailmultiple;
  uploadfile: boolean = false;
  senderNameDropDown: any;

  @ViewChild('selectedFileNames') selectedFileNames: ElementRef;
  @ViewChild('subjectId') subjectId: NgSelectComponent;
  @ViewChild('remarkId') remarkId: NgSelectComponent;
  @ViewChild('specificationId') specificationId: NgSelectComponent;

  eyeIconViewData: string = "zmdi-eye-off";
  starIconViewData: string = "zmdi-star-outline";

  constructor(private fb: FormBuilder,private router: Router, private uploadService: UploadFileS3BucketService, private global: Globals, private _hiddenService: ShowHiddenService, private _pendingRequestService: PendingRequestService, private _approvedService: ApprovedService, private chRef: ChangeDetectorRef, private datePipe: DatePipe) { }

  ngOnInit() {
    localStorage.setItem("Active Route", this.router.url);
    this.global.afterRefreshPageSetToken();
    this.GetHidden_Grid();
    this.todayDate = new Date();

    var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
    var localISOTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1);

    var changedate = this.datePipe.transform(localISOTime, 'yyyy-MM-ddTHH:mm');
    this.addApprovedHealthCard.dateTime = changedate;
    $(".modal-wide").on("show.bs.modal", function () {
      var height = $(window).height() - 80;
      $(this).find(".modal-body").css("max-height", height);
    });
    this.getSecification();
    this.loadSendEmailForm();
  }

  GetHidden_Grid() {
    this._hiddenService.GetHiddenList()
      .subscribe((response) => {
        if ($.fn.dataTable.isDataTable('#hiddenDatatable')) {
          $('#hiddenDatatable').dataTable().fnClearTable();
          $('#hiddenDatatable').dataTable().fnDestroy();
        }

        if ($.fn.dataTable.isDataTable('#hiddenDatatable_IsMobile')) {
          $('#hiddenDatatable_IsMobile').dataTable().fnClearTable();
          $('#hiddenDatatable_IsMobile').dataTable().fnDestroy();
        }

        Object.assign(this.hiddenGrid, response);
        this.hiddenGrid.forEach((element) => {

          if (element.sub.length == 0) {
            element.subBindGrid = "";
          } else {
            element.sub.forEach((elem) => {
              if (element.subBindGrid == undefined) {
                element.subBindGrid = elem.name
              }
              else {
                element.subBindGrid = element.subBindGrid + ',' + elem.name;
              }
              // element.subBindGrid="";
            })
          }
          if (element.spec.length == 0) {
            element.specBindGrid = "";
          } else {
            element.spec.forEach((elem) => {
              if (element.specBindGrid == undefined) { element.specBindGrid = elem.name }
              else { element.specBindGrid = element.specBindGrid + ',' + elem.name; }
            })
          }
          if (element.remark.length == 0) {
            element.remarkBindGrid = "";
          } else {
            element.remark.forEach((elem) => {
              if (element.remarkBindGrid == undefined) { element.remarkBindGrid = elem.name }
              else { element.remarkBindGrid = element.remarkBindGrid + ',' + elem.name; }
            })
          }
        });
        this.chRef.detectChanges();
        $("#hiddenDatatable").DataTable({
          "paging": false,
          "info": false,
          "order": [[8, 'desc']],
          'columnDefs': [{ 'orderable': false, 'targets': 0 }],
          dom: 'Bfrtip',
          buttons: [
            { extend: 'pdf', title: 'Hidden Pdf', attr: { id: "pdfBtn" }, exportOptions: { columns: [2, 3, 4, 5, 6, 7, 9] } },
            { extend: 'excel', title: 'Hidden Excel', attr: { id: "excelBtn" }, exportOptions: { columns: [2, 3, 4, 5, 6, 7, 9] } }
          ],
          "fnDrawCallback": function () {
            var table = $('#hiddenDatatable').DataTable();
            $(table.buttons('.buttons-pdf').nodes()).css("display", "none");
            $(table.buttons('.buttons-excel').nodes()).css("display", "none");
          }



        });
        $("#hiddenDatatable_filter").hide();
        $("#hiddenDatatable_IsMobile").DataTable({
          "paging": false,
          "info": false,
          "order": [[3, 'desc']],
          'columnDefs': [{ 'orderable': false, 'targets': 0 }],
          dom: 'Bfrtip',
          buttons: [
            { extend: 'pdf', title: 'Hidden Pdf', attr: { id: "pdfBtn_IsMobile" }, exportOptions: { columns: [2, 4] } },
            { extend: 'excel', title: 'Hidden Excel', attr: { id: "excelBtn_IsMobile" }, exportOptions: { columns: [2, 4] } }
          ],
          "fnDrawCallback": function () {
            var table = $('#hiddenDatatable_IsMobile').DataTable();
            $(table.buttons('.buttons-pdf').nodes()).css("display", "none");
            $(table.buttons('.buttons-excel').nodes()).css("display", "none");
          }
        });
        $("#hiddenDatatable_IsMobile_filter").hide();
      },
        error => {
        })
  }
  ExportExcel() {
    $("#excelBtn").click();
  }

  ExportPdf() {
    $("#pdfBtn").click();
  }


  ExportExcel_IsMobile() {
    $("#excelBtn_IsMobile").click();
  }

  ExportPdf_IsMobile() {
    $("#pdfBtn_IsMobile").click();
  }


  getSecification() {
    //Specification Dropdown
    this._pendingRequestService.GetAllSpecification()
      .subscribe((response) => {
        this.specificationDropDown = response;
        console.log(response);
      },
        error => {
          console.log(error);
        })

    //Specification Dropdown

  }

  //Add approved
  Add_PreDataBind() {
    var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
    var localISOTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1);
    var changedate = this.datePipe.transform(localISOTime, 'yyyy-MM-ddTHH:mm');
    this.addApprovedHealthCard.dateTime = changedate;
    this.getSenderName();
    //Subject Dropdown
    this._pendingRequestService.GetAllSubject()
      .subscribe((response) => {
        this.subjectDropDown = response;
        console.log(response);
      },
        error => {
          console.log(error);
        })

    //Specification Dropdown
    // this._pendingRequestService.GetAllSpecification()
    //   .subscribe((response) => {
    //     this.specificationDropDown = response;
    //     console.log(response);
    //   },
    //     error => {
    //       console.log(error);
    //     })

    //Specification Dropdown
    this._pendingRequestService.GetAllRemark()
      .subscribe((response) => {
        this.remarkDropDown = response;
        console.log(response);
      },
        error => {
          console.log(error);
        })
  }
  ApprovedHealthSubmit(addForm: NgForm) {
    debugger;
    //sub data

    // if(this.uploadfile){
    //   if( Globals.attachmentStatus == true){
    this.submitted = true;
    if (addForm.form.invalid) {

      if (addForm.form.controls.senderId.invalid) {
        $("#senderIdError").html("Sender Name is required")
      } else {
        $("#senderIdError").html("")
      }
      if (addForm.form.controls.subjectDropDown_SelectedId.invalid) {
        $("#subjectIdError").html("Subject Name is required")
      } else {
        $("#subjectIdError").html("")
      }
      return;
    }
    var localsub: Sub[] = new Array();
    if (this.subjectDropDown_SelectedId != undefined) {
      for (let data of this.subjectDropDown_SelectedId) {
        if (isNaN(data)) {
          var newSub: Sub = {
            subjectId: 0,
            name: data.toString(),
          }
          localsub.push(newSub);
        }
        else {
          var oldSub: Sub = {
            subjectId: data,
            name: this.subjectDropDown.find(a => a.subjectId == data).name,
          }
          localsub.push(oldSub);
        }
      }
    }
    //spec data
    var localspec: Specification[] = new Array();
    if (this.specificationDropDown_SelectedId != undefined) {
      for (let data of this.specificationDropDown_SelectedId) {
        if (isNaN(data)) {
          var newSpec: Specification = {
            specificationId: 0,
            name: data.toString(),
          }
          localspec.push(newSpec);
        }
        else {
          var oldSpec: Specification = {
            specificationId: data,
            name: this.specificationDropDown.find(a => a.specificationId == data).name,
          }
          localspec.push(oldSpec);
        }
      }
    }
    //remark data
    var localrmk: Remark[] = new Array();
    if (this.remarkDropDown_SelectedId != undefined) {
      for (let data of this.remarkDropDown_SelectedId) {
        if (isNaN(data)) {
          var newRmk: Remark = {
            remarkId: 0,
            name: data.toString(),
          }
          localrmk.push(newRmk);
        }
        else {
          var oldRmk: Remark = {
            remarkId: data,
            name: this.remarkDropDown.find(a => a.remarkId == data).name,
          }
          localrmk.push(oldRmk);
        }
      }
    }
    this.addApprovedHealthCard.sub = localsub;
    this.addApprovedHealthCard.spec = localspec;
    this.addApprovedHealthCard.remark = localrmk;
    //attachment
    if (this.uploadfile) {
      if (Globals.attachmentStatus == true) {
        var s3path = "https://mdhl.s3.ap-south-1.amazonaws.com/"
        for (var i = 0; i < this.selectedFiles.length; i++) {
          this.attachdata = new Attachment();
          this.attachdata.filePath = s3path + this.global.loggedUser.user.user_reg_id + "/" + this.selectedFiles[i].name;
          this.attachdata.fileSize = this.selectedFiles[i].size;
          this.attachdata.fileType = this.selectedFiles[i].type.split("/")[1];
          this.attachdata.user_id = this.global.loggedUser.user.user_reg_id;
          this.attachdata.fileName = this.selectedFiles[i].name;
          //     this._attachmentService.SaveAttchment(this.attachdata).subscribe((response) => {
          //       this.attachdata.fileId=response.fileId;
          //  info_noti("attachemnt called reponse "+i +" "+this.attachdata.fileId);
          //       console.log("attachment List "+response);
          //     },err=>{

          //     });
          this.attchmentList.push(this.attachdata);
        }

        this.addApprovedHealthCard.attachment = this.attchmentList;

        console.log(this.attchmentList);
        this.addApprovedHealthCard.hide = true;
        this._approvedService.AddApproved_HealthCard(this.addApprovedHealthCard)
          .subscribe((response) => {
            this.submitted = false;
            this.addForm.resetForm();
            this.addCloseForm.nativeElement.click();
            this.GetHidden_Grid();
            this.selectedFiles = [];
            this.attchmentList = [];
            Globals.attachmentStatus == true
            this.eyeIcon = "zmdi-eye-off";
            this.starIcon = "zmdi-star-outline";
            $("#file").val('');
            this.uploadfile = false;
            info_noti("HealthCard added successfully");
          },
            error => {
              this.submitted = false;
              info_noti(error);
            })
      } else {
        info_noti("please wait for upload file")
        return false;
      }

    } else {
      this.addApprovedHealthCard.hide = true;
      this._approvedService.AddApproved_HealthCard(this.addApprovedHealthCard)
        .subscribe((response) => {
          this.submitted = false;
          this.addForm.resetForm();
          this.addCloseForm.nativeElement.click();
          this.GetHidden_Grid();
          this.selectedFiles = [];
          this.attchmentList = [];
          Globals.attachmentStatus == true
          this.eyeIcon = "zmdi-eye-off";
          this.starIcon = "zmdi-star-outline";
          $("#file").val('');
          this.uploadfile = false;
          info_noti("HealthCard added successfully");
        },
          error => {
            this.submitted = false;
            info_noti(error);
          })
    }

  }

  addCancelClick() {
    this.addForm.resetForm();
    $('#file').val('');
    this.selectedFileNames.nativeElement.innerHTML = '';
    this.submitted = false;
  }

  Add_CloseClick() {
    this.addForm.resetForm();
    $('#file').val('');
    this.selectedFileNames.nativeElement.innerHTML = '';
    this.submitted = false;
  }
  Eye_Click() {
    this.eyeIcon = this.eyeIcon == "zmdi-eye" ? "zmdi-eye-off" : "zmdi-eye";
    this.addApprovedHealthCard.hide = this.eyeIcon == "zmdi-eye" ? true : false;
  }

  Star_Click() {
    this.starIcon = this.starIcon == "zmdi-star" ? "zmdi-star-outline" : "zmdi-star";
    this.addApprovedHealthCard.star = this.starIcon == "zmdi-star" ? true : false;
  }

  //DropDown Functions//
  subjectDropDown_Added = (term) => ({ subjectId: term, name: term });
  specificationDropDown_Added = (term) => ({ specificationId: term, name: term });
  remarkDropDown_Added = (term) => ({ remarkId: term, name: term });
  senderDropDown_Added = (term) => ({ senderId: term, name: term });
  //DropDown Functions//



  checkYear(data): Boolean {
    let userDate = new Date(data);
    if (userDate.getFullYear() == this.todayDate.getFullYear()) {
      return true;
    }
    else {
      return false;
    }
  }

  ViewDataBind(data: Approved) {
    Object.assign(this.hiddenViewData, data);
  }

  // checkboxChanged(event, obj) {
  //   if (event.target.checked) {
  //     this.selectedMailList.push(event.target.value);
  //   }
  //   else {
  //     this.selectedMailList.splice(this.selectedMailList.indexOf(event.target.value), 1);
  //   }
  //   this.selectedMailList = Array.from(new Set(this.selectedMailList));

  //   if (this.selectedMailList.length > 0) {
  //     this.showActions = true;
  //     if (this.checkClickCount == 0) {
  //       this.checkClickCount = 1;
  //       this.approvedObjActionShow = obj;
  //     }
  //   }
  //   else {
  //     this.showActions = false;
  //     this.checkClickCount = 0;
  //     this.approvedObjActionShow = null;
  //   }
  // }

  checkboxChanged(event, obj, status, allSelectedList, type) {
    debugger;
    if (type == "mobile") {
      if (status == "selectAll") {
        if (event.target.checked) {
          var i = 1;
          allSelectedList.forEach(element => {
            this.selectedMailList.push(element.appEmailId);
            $('#checkboxm' + i).prop("checked", true);
            i++;
          })
        } else {

          var i = 1;

          allSelectedList.forEach(element => {
            this.selectedMailList.splice(this.selectedMailList.indexOf(element.appEmailId, 1));

            $('#checkboxm' + i).prop("checked", false);
            i++;
          })
        }

      } else {

        if (event.target.checked) {
          this.selectedMailList.push(obj.appEmailId);
          if (this.selectedMailList.length == this.hiddenGrid.length) {
            $('#selectAllm').prop("checked", true);
          }

        }
        else {
          $('#selectAllm').prop("checked", false);
          this.selectedMailList.splice(this.selectedMailList.indexOf(obj.appEmailId), 1);
        }
      }
      this.selectedMailList = Array.from(new Set(this.selectedMailList));

      if (this.selectedMailList.length > 0) {
        this.showActions = true;
        if (this.checkClickCount == 0) {
          this.checkClickCount = 1;
          this.approvedObjActionShow = obj;
        }
      }
      else {
        this.checkClickCount = 0;
        this.approvedObjActionShow = null;
        this.showActions = false;
      }
    } else {
      if (status == "selectAll") {
        if (event.target.checked) {
          var i = 1;
          allSelectedList.forEach(element => {
            this.selectedMailList.push(element.appEmailId);
            $('#checkbox' + i).prop("checked", true);
            i++;
          })
        } else {

          var i = 1;

          allSelectedList.forEach(element => {
            this.selectedMailList.splice(this.selectedMailList.indexOf(element.appEmailId, 1));

            $('#checkbox' + i).prop("checked", false);
            i++;
          })
        }

      } else {

        if (event.target.checked) {
          this.selectedMailList.push(obj.appEmailId);
          if (this.selectedMailList.length == this.hiddenGrid.length) {
            $('#selectAll').prop("checked", true);
          }

        }
        else {
          $('#selectAll').prop("checked", false);
          this.selectedMailList.splice(this.selectedMailList.indexOf(obj.appEmailId), 1);
        }
      }
      this.selectedMailList = Array.from(new Set(this.selectedMailList));

      if (this.selectedMailList.length > 0) {
        this.showActions = true;
        if (this.checkClickCount == 0) {
          this.checkClickCount = 1;
          this.approvedObjActionShow = obj;
        }
      }
      else {
        this.checkClickCount = 0;
        this.approvedObjActionShow = null;
        this.showActions = false;
      }
    }

  }




  StarClick(appEmailId, star, status) {
    debugger;
    this._approvedService.starUnstar(appEmailId, star)
      .subscribe((response) => {
        // console.log(response);

        if (star == 1) {
          info_noti('Starred Success...');
        } else {
          info_noti('UnStarred Success...');
        }
        this.GetHidden_Grid();
      })
  }

  HideClick(appEmailId, hide, status) {
    if (status == 'ViewModal') {
      $("#ViewModal").modal("hide");
      $("body").removeClass('modal-open');
      $('.modal-backdrop').remove();
    }
    this._approvedService.hideUnhide(appEmailId, hide)
      .subscribe((response) => {
        info_noti('Show Success...');
        this.GetHidden_Grid();
      })
  }

  //Delete
  DeleteApproved(id: any, status) {
    debugger;
    if (status == 'ViewModal') {
      $("#ViewModal").modal("hide");
      $("body").removeClass('modal-open');
      $('.modal-backdrop').remove();
    }
    this._approvedService.Delete_HealthCard(id)
      .subscribe((response) => {
        debugger;
        info_noti('Deleted Success...');
        this.GetHidden_Grid();
      });
  }

  multipleDelete() {
    debugger;
    for (var i = 0; i < this.selectedMailList.length; i++) {
      this.appvar = new Approved();
      this.appvar.appEmailId = Number(this.selectedMailList[i]);
      this.selectedActionList[i] = this.appvar;
    }
    this._approvedService.deleteMultiple(this.selectedActionList).subscribe((response) => {
      info_noti('Deleted Success...');
      this.selectedMailList.length = 0;

      this.selectedActionList.length = 0;
      if (this.selectedMailList.length > 0) {
        this.showActions = true;
      }
      else {
        this.checkClickCount = 0;
        this.approvedObjActionShow = null;
        this.showActions = false;
      }
      $('#selectAll').prop("checked", false);
      $('#selectAllm').prop("checked", false);
      this.GetHidden_Grid();
    }, error => { info_noti(error); }
    );
    console.log(this.selectedMailList);
  }


  multipleStar(flag: boolean) {
    debugger;

    for (var i = 0; i < this.selectedMailList.length; i++) {
      this.appvar = new Approved();
      this.appvar.appEmailId = Number(this.selectedMailList[i]);
      this.appvar.star = flag;

      this.selectedActionList[i] = this.appvar;
    }
    this._approvedService.starMultiple(this.selectedActionList).subscribe((response) => {
      info_noti('Starred Success...');
      //  info_noti("Starred Success...");
      this.selectedMailList.length = 0;

      this.selectedActionList.length = 0;
      if (this.selectedMailList.length > 0) {
        this.showActions = true;
      }
      else {
        this.checkClickCount = 0;
        this.approvedObjActionShow = null;
        this.showActions = false;
      }
      $('#selectAll').prop("checked", false);
      $('#selectAllm').prop("checked", false);
      this.GetHidden_Grid();
    }, error => { info_noti(error); }
    );


    console.log(this.selectedMailList);

  }
  multipleEye(flag: boolean) {
    debugger;
    for (var i = 0; i < this.selectedMailList.length; i++) {
      this.appvar = new Approved();
      this.appvar.appEmailId = Number(this.selectedMailList[i]);
      this.appvar.hide = flag;
      this.selectedActionList[i] = this.appvar;
    }
    this._approvedService.hideMultiple(this.selectedActionList).subscribe((response) => {
      info_noti('Show Success...');
      this.selectedMailList.length = 0;
      this.appvar
      this.selectedActionList.length = 0;
      if (this.selectedMailList.length > 0) {
        this.showActions = true;
      }
      else {
        this.checkClickCount = 0;
        this.approvedObjActionShow = null;
        this.showActions = false;
      }
      $('#selectAll').prop("checked", false);
      $('#selectAllm').prop("checked", false);
      this.GetHidden_Grid();
    }, error => { info_noti(error); }
    );
    console.log(this.selectedMailList);

  }
  onFileChange(event) {
    this.selectedFileNames.nativeElement.innerHTML = '';
    this.selectedFiles = event.target.files;
    console.log(event.target.files);
    if (this.selectedFiles.length > 0) {
      this.uploadfile = true;
      for (let i = 0; i < this.selectedFiles.length; i++) {
        this.selectedFileNames.nativeElement.innerHTML += this.selectedFiles[i].name + "<br/>";
      }
      this.uploadService.uploadfile(this.selectedFiles, "");
    }



    //  this.uploadService.SaveAttchment().subscribe((response)=>{
    // var attchment=response;
    // console.log(attchment);

    //  });
  }

  // onlyDigitEnter(event){
  //   console.log("amount digit only")
  //   $(document).ready(function () {
  //     //called when key is pressed in textbox
  //     $("#amount1").keypress(function (event) {
  //       //if the letter is not digit then display error and don't type anything
  //       if (event.which != 8 && event.which != 0 && (event.which < 48 || event.which > 57)) {
  //         //display error message
  //         $("#errmsg").html("Digits Only").show().fadeOut("slow");
  //         return false;
  //       }
  //     });
  //   });
  // }
  AttachmentShow_DataBind(data) {
    this.showhiddenAttachmentDataShow = data;

  }
  Attachment_DataBind(data: any) {
    this.showhiddenAttachmentData = data;
  }
  Attachment_CloseClick() {
    this.attachment_CloseForm.nativeElement.click();
  }


  enteredEmailIDForForwordEmail(emailId) {
    this.emailId = emailId;
  }
  multipleForword(emailId,form:NgForm) {
    if (emailId != "") {
      $("#multipleForwordBtn").attr("disabled", true);
      for (var i = 0; i < this.selectedMailList.length; i++) {
        this.appvar = new Approved();
        this.appvar.appEmailId = Number(this.selectedMailList[i]);
        this.selectedActionList[i] = this.appvar;
      }
      
      this.sendEmailmultiple.approved = this.selectedActionList;
      // this.sendEmailmultiple.emailid = emailId;
      
      this.sendEmailmultiple.emailid = this.sendEmailForm.controls['toAddress'].value;
      
    
      this._approvedService.forwordMultiple(this.sendEmailmultiple).subscribe((response) => {
        info_noti("Email Send Success...");
        $("#multipleForwordBtn").attr("disabled", false);
        $('#sendForwordemail').val('');
        $("#sendEmailForMultipleForword").modal("hide");
        $("body").removeClass('modal-open');
        $('.modal-backdrop').remove();
        this.selectedMailList.length = 0;
        
        this.selectedActionList.length = 0;
        if (this.selectedMailList.length > 0) {
          this.showActions = true;
        }
        else {
          this.approvedObjActionShow = null;
          this.showActions = false;
          this.checkClickCount = 0;
          this.sendEmailmultiple = new sendEmailmultiple;
        }
        $('#selectAll').prop("checked", false);
        $('#selectAllm').prop("checked", false);
        this.GetHidden_Grid();
       
       
      }, error => {
        info_noti("Email Not send");
        
        $("#sendEmailForMultipleForword").modal("hide");
        $("body").removeClass('modal-open');
        $('.modal-backdrop').remove();
      }
      );
      console.log(this.selectedMailList);
    } else {
      this.emailId = '';
      console.log(this.emailId);
    }


  }
	  
	  
	  
	
	  
	    sendEmailForm: FormGroup;
  loadSendEmailForm(){
      this.sendEmailForm = this.fb.group({
        'toAddress': ['', [Validators.required, this.commaSepEmail]]
      });
    }
  
    send(value) {
      console.log(value);
    }
  
    commaSepEmail = (control: AbstractControl): { [key: string]: any } | null => {
      const emails = control.value.split(',');
      const forbidden = emails.some(email => Validators.email(new FormControl(email)));
      console.log(forbidden);
      return forbidden ? { 'toAddress': { value: control.value } } : null;
    };
	
	
	 sendForwordEmailOpen() {
    this.loadSendEmailForm();
    $('#sendForwordemail').focus();

  }

	 
  forwordEmailEnter(sendForwordemail,form:NgForm) {
    $('#multipleForwordBtn').focus();
    this.multipleForword(sendForwordemail,form);
  }
  sendMailClose(form:NgForm) {
    $('#sendForwordemail').val('');
    this.emailId = "";
   
  }

  updateUsingViewModel(id) {
    $("#ViewModal").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

    this.router.navigate(['/dashboard/updatehc/' + id + '/approved']);
  }
 
  senderIdEnter() {
    this.subjectId.focus();
  }
  subjectEnter() {
    $('#body').focus();
  }
  bodyEnter() {
    $('#date_time').focus();
  }
  dateEnter() {
    this.specificationId.focus();

  }
  spcificationEnter() {
    $('#amount').focus();
  }
  amountEnter() {
    this.remarkId.focus();

  }
  remarkEnter() {
    $('#eyeIcon').focus();
  }
  eyeEnter() {
    $('#starIcon').focus();
  }
  starEnter() {
    $('#saveBtn').focus();
  }
  //browser back button or mobile back button
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {

    $("#AddShowHiddenModal").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

    $("#ViewModal").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

    $("#AttachmentModal").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

    $("#attchmentShowModal").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

    $("#sendEmailForMultipleForword").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

  }
  getSenderName() {
    this._approvedService.GetSenderName().subscribe(res => {
      this.senderNameDropDown = res;
      // Object.assign(this.senderNameDropDown, res);

      console.log("Sender Name:" + this.senderNameDropDown)
    }, err => {
      info_noti("Error To get Sender Name")
    })

  }
  downloadFile(path) {
    console.log(path);
    window.open(path, '_self');
  }

  Eye_ClickViewData(appEmailId) {
    debugger

    if (this.eyeIconViewData == "zmdi-eye") {
      this.eyeIconViewData = "zmdi-eye-off";
      this.HideClick(appEmailId, 0, 'ViewModal');
    } else {
      this.eyeIconViewData = "zmdi-eye";
      this.HideClick(appEmailId, 1, '');
    }


  }
  Star_ClickViewData(appEmailId) {
    debugger

    if (this.starIconViewData == "zmdi-star") {
      this.starIconViewData = "zmdi-star-outline";
      this.StarClick(appEmailId, 0, 'viewData');
    } else {
      this.starIconViewData = "zmdi-star";
      this.StarClick(appEmailId, 1, 'viewData');
    }

  }

}
